// extracted by mini-css-extract-plugin
export default {"wrap":"GG-z","fullWidth":"HG-z","hideOnDesktop":"IG-z","content":"JG-z","hasOpenedNav":"KG-z","crumbsList":"LG-z","dropdownsWrap":"MG-z"};